/**
 * main_bottom_ingredients.js - v06
 * - Correctly handles first/last classes for visible items in the list (Right)
 */

(function() {
  const initSection = (section) => {
    const tabs = section.querySelectorAll('.main-ingredients__tab');
    const heroArea = section.querySelector('[data-ingredients-hero]');
    const listArea = section.querySelector('[data-ingredients-list]');
    const allItems = listArea.querySelectorAll('.main-ingredients__item');

    const updateView = (category) => {
      let visibleItems = [];
      
      allItems.forEach(item => {
        if (category === 'all' || item.dataset.category === category) {
          item.classList.remove('hidden');
          visibleItems.push(item);
        } else {
          item.classList.add('hidden');
        }
      });

      if (visibleItems.length > 0) {
        const first = visibleItems[0];
        const innerContent = first.querySelector('.main-ingredients__item-inner').innerHTML;
        
        const heroContent = `
          <div class="main-ingredients__item-inner">
            ${innerContent}
          </div>
        `;
        heroArea.innerHTML = heroContent;
        first.classList.add('hidden');
        
        // Remove the one already shown in Hero from the list count
        visibleItems.shift(); 
      } else {
        heroArea.innerHTML = '<div class="main-ingredients__hero-placeholder" style="padding:40px; color:#999;">No ingredients found in this category.</div>';
      }
      
      // Reset and apply helper classes for uniform spacing
      allItems.forEach(item => {
        item.classList.remove('list-item-first', 'list-item-last');
      });
      
      if (visibleItems.length > 0) {
        visibleItems[0].classList.add('list-item-first');
        visibleItems[visibleItems.length - 1].classList.add('list-item-last');
      }
    };

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('is-active'));
        tab.classList.add('is-active');
        updateView(tab.dataset.category);
      });
    });

    const activeTab = section.querySelector('.main-ingredients__tab.is-active');
    if (activeTab) {
      updateView(activeTab.dataset.category);
    } else if (tabs.length > 0) {
      tabs[0].classList.add('is-active');
      updateView(tabs[0].dataset.category);
    }
  };

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.classList.contains('main-ingredients')) {
      initSection(e.target);
    }
  });

  document.querySelectorAll('.main-ingredients').forEach(initSection);
})();
